import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { dbActions } from '../../../redux/modules/firebase/databaseModule';

class GoalDetails extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            subscription: [],
        };
    }

    _subscribeToGoal(props) {
        const { user, id, goal, getGoal, subscribeToGoal } = props;
        this.setState({ loading: true });
        if (user && user.uid && id) {
            const uid = user.uid;
            const goalPromise = goal ? Promise.resolve() : getGoal(uid, id);
            goalPromise
                .then(() => subscribeToGoal(uid, id))
                .then(() => {
                    this.setState({
                        loading: false,
                        subscription: [uid, id],
                    });
                });
        }
    }

    _unsubscribeToGoal(updateState = true) {
        const { subscription: [ uid, id ]} = this.state;
        const { unsubscribeToGoal } = this.props;
        if (uid && id) {
            unsubscribeToGoal(uid, id)
                .then(() => {
                    if (updateState) {
                        this.setState({ subscription: [] });
                    }
                });
        }
    }

    componentWillMount() {
        this._subscribeToGoal(this.props);
    }

    componentWillUnmount() {
        this._unsubscribeToGoal(false);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.user !== nextProps.user || this.props.id !== nextProps.id) {
            this._unsubscribeToGoal();
            if (nextProps.user && nextProps.id) {
                this._subscribeToGoal(nextProps);
            }
        }
    }

    render() {
        const { goal } = this.props;
        const { loading } = this.state;

        if (loading) {
            // TODO clean up
            return <div>Loading</div>;
        }

        if (!goal) {
            // TODO clean up
            return <div>Goal Not Found</div>;
        }

        return (
            <div>A Goal</div>
        );
    }
}

GoalDetails.propTypes = {
    id: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired,
    goal: PropTypes.object,
};

export default connect((state, props) => {
    const user = state.user.get('user');
    const goalId = props.match.params.id;

    let goal = null;
    if (user && user.uid) {
        goal = state.firebase.getIn(['goals', user.uid, goalId]);
    }

    return { id: goalId, user, goal };
}, dispatch => ({
    dispatch,
    getGoal(uid, goalId) {
        return dispatch(dbActions.firebase.database.get(`goals/${uid}/${goalId}`));
    },
    subscribeToGoal(uid, goalId) {
        return dispatch(dbActions.firebase.database.subscribe(`goals/${uid}/${goalId}`));
    },
    unsubscribeToGoal(uid, goalId) {
        return dispatch(dbActions.firebase.database.unsubscribe(`goals/${uid}/${goalId}`));
    },
}))(GoalDetails);



// WEBPACK FOOTER //
// ./src/components/pages/goals/GoalDetails.js